import React, { useState, useContext } from "react";
import Markdown from "react-markdown";
import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import classNames from "classnames";
import { makeStyles } from "@material-ui/styles";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import { AppContext, OPEN_TOAST } from "../Context";
import { uriWithCulture } from "./util";

const useStyles = makeStyles((theme) => ({
  payment: {},
  dialog: {
    width: "500px",
    minHeight: "200px",
    "@media(max-width: 600)": {
      width: "100%",
    },
  },
  title: {
    color: theme.app.labelColor,
    borderBottom: `1px solid ${theme.app.borderColor}`,
  },
  terms: {
    maxHeight: "250px",
    overflow: "auto",
    padding: "8px 16px",
    color: theme.app.secondaryColor,
    background: theme.app.background[0],
    fontSize: "0.875rem",
    "@media(max-width: 600px)": {
      maxHeight: `${theme.height - 180}px`,
    },
  },
  cbContainer: {
    borderTop: `1px solid ${theme.app.borderColor}`,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "8px 16px",
  },
  cbLabel: { color: theme.app.labelColor, fontSize: "0.875rem" },
  abortButton: { color: theme.app.labelColor },
}));

const PAY_BOOKING = gql`
  mutation initiatePayment {
    initiatePayment {
      uri
    }
  }
`;

const Payment = (props) => {
  const { open, handleClose, language, culture } = props;
  const classes = useStyles();
  const [confirmed, setConfirmed] = useState(false);
  const context = useContext(AppContext);
  const { dispatch, state } = context;
  const { termsText } = state;
  const handleMutationSuccess = (data) => 
  (window.location = uriWithCulture(data.initiatePayment.uri, culture));
  const handleMutationError = (error) =>
    dispatch({ type: OPEN_TOAST, toastText: error, toastType: "error" });
  const [initiatePayment, { loading }] = useMutation(PAY_BOOKING, {
    onError: handleMutationError,
    onCompleted: handleMutationSuccess,
  });

  return (
    <Dialog
      classes={{ paper: classes.dialog }}
      open={open}
      onClose={handleClose}
      fullScreen={window.innerWidth < 601}
    >
      <DialogTitle className={classes.title}>
        {language.pay_bookings}
      </DialogTitle>
      <DialogContent className={classes.contentContainer}>
        <div
          className={classNames(classes.terms, "terms__text-container")}
          id="terms"
        >
          <Markdown source={termsText} escapeHtml={false} skipHtml={false} />
        </div>
        <div className={classes.cbContainer}>
          <FormControlLabel
            labelPlacement="start"
            classes={{ label: classes.cbLabel }}
            control={
              <Checkbox
                checked={confirmed}
                onChange={() => setConfirmed(!confirmed)}
              />
            }
            label={language.accept_terms}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          size="small"
          className={classes.abortButton}
        >
          {language.abort}
        </Button>
        <Button
          disabled={!confirmed || loading}
          onClick={initiatePayment}
          color="primary"
          size="small"
          className={classes.button}
        >
          {language.pay}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Payment;
